import { Component, type ReactNode } from 'react';

type Props = { children: ReactNode };
type State = { error: Error | null };

/** Последний рубеж: краш рендера не должен превращаться в белый экран PWA. */
export default class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: { componentStack?: string | null }) {
    console.error('render crash:', error, info.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div style={{ padding: 24, fontFamily: 'system-ui, sans-serif', textAlign: 'center' }}>
        <h1 style={{ fontSize: 20, marginBottom: 8 }}>Что-то сломалось</h1>
        <p style={{ color: '#666', marginBottom: 16 }}>
          Данные целы — они на сервере и в локальном кэше.
        </p>
        <button
          onClick={() => window.location.reload()}
          style={{ padding: '10px 24px', fontSize: 16, cursor: 'pointer' }}
        >
          Перезагрузить
        </button>
      </div>
    );
  }
}
